var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",class:{
    'sidebar--open': _vm.menuOpen,
    'sidebar--closed': _vm.hideSidebar,
    'sidebar--deprecation-banner': _vm.isDeprecationBannerShown
  },style:({ '--banner-height': _vm.deprecationBannerHeight + 'px' }),attrs:{"data-cy":"sidebar"},on:{"transitionend":_vm.handleTransitionend}},[_c('div',{staticClass:"sidebar__overlay",on:{"click":_vm.hideMenu}}),_vm._v(" "),_c('aside',{staticClass:"sidebar__content",class:`u-bg-${_vm.bgColor}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }